import React, { useMemo } from "react";
import styled from "styled-components";

interface Props {
  size?: "sm" | "md" | "lg";
  loading?: boolean;
}

const ActivityIndicator: React.FC<Props> = (props) => {
  const { loading, size = "sm" } = props;

  const containerSize = useMemo(() => {
    switch (size) {
      case "sm": {
        return 18;
      }
      case "md": {
        return 24;
      }
      case "lg": {
        return 36;
      }
    }
  }, [size]);

  const itemWidth = useMemo(() => {
    switch (size) {
      case "sm": {
        return 2;
      }
      case "md": {
        return 2;
      }
      case "lg": {
        return 4;
      }
    }
  }, [size]);

  const itemHeight = useMemo(() => {
    switch (size) {
      case "sm": {
        return 5;
      }
      case "md": {
        return 8;
      }
      case "lg": {
        return 12;
      }
    }
  }, [size]);

  if (!loading) return null;
  return (
    <Container
      contentSize={containerSize}
      itemWidth={itemWidth}
      itemHeight={itemHeight}
    >
      <div className="spinner">
        <div className="bar1"></div>
        <div className="bar2"></div>
        <div className="bar3"></div>
        <div className="bar4"></div>
        <div className="bar5"></div>
        <div className="bar6"></div>
        <div className="bar7"></div>
        <div className="bar8"></div>
        <div className="bar9"></div>
        <div className="bar10"></div>
        <div className="bar11"></div>
        <div className="bar12"></div>
      </div>
    </Container>
  );
};

const Container = styled.div<{
  contentSize: number;
  itemWidth: number;
  itemHeight: number;
}>`
  div.spinner {
    position: relative;
    width: ${(props) => props.contentSize}px;
    height: ${(props) => props.contentSize}px;
    background: transparent;
  }

  div.spinner > div {
    width: ${(props) => props.itemWidth}px;
    height: ${(props) => props.itemHeight}px;

    background: ${(props) => props.theme.colors.disabled};
    position: absolute;
    left: 49%;
    top: 38%;
    opacity: 0;
    border-radius: 50px;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
    animation: fade 1s linear infinite;
  }

  @keyframes fade {
    from {
      opacity: 1;
    }
    to {
      opacity: 0.25;
    }
  }

  div.spinner div.bar1 {
    transform: rotate(0deg) translate(0, -130%);
    animation-delay: 0s;
  }

  div.spinner div.bar2 {
    transform: rotate(30deg) translate(0, -130%);
    animation-delay: -0.9167s;
  }

  div.spinner div.bar3 {
    transform: rotate(60deg) translate(0, -130%);
    animation-delay: -0.833s;
  }
  div.spinner div.bar4 {
    transform: rotate(90deg) translate(0, -130%);
    animation-delay: -0.7497s;
  }
  div.spinner div.bar5 {
    transform: rotate(120deg) translate(0, -130%);
    animation-delay: -0.667s;
  }
  div.spinner div.bar6 {
    transform: rotate(150deg) translate(0, -130%);
    animation-delay: -0.5837s;
  }
  div.spinner div.bar7 {
    transform: rotate(180deg) translate(0, -130%);
    animation-delay: -0.5s;
  }
  div.spinner div.bar8 {
    transform: rotate(210deg) translate(0, -130%);
    animation-delay: -0.4167s;
  }
  div.spinner div.bar9 {
    transform: rotate(240deg) translate(0, -130%);
    animation-delay: -0.333s;
  }
  div.spinner div.bar10 {
    transform: rotate(270deg) translate(0, -130%);
    animation-delay: -0.2497s;
  }
  div.spinner div.bar11 {
    transform: rotate(300deg) translate(0, -130%);
    animation-delay: -0.167s;
  }
  div.spinner div.bar12 {
    transform: rotate(330deg) translate(0, -130%);
    animation-delay: -0.0833s;
  }
`;

export default ActivityIndicator;
